exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--1g-8zMFzWzZ7qJqB1t8j1O {\n  font-size: .75rem;\n  line-height: 1.5rem;\n  text-decoration-line: underline !important;\n  font-weight: 400 !important;\n  color: #0078bc !important;\n}\n", ""]);

// exports
exports.locals = {
	"sidebarLink": "waiting-room-sidebar--1g-8zMFzWzZ7qJqB1t8j1O",
	"sidebarLink": "waiting-room-sidebar--1g-8zMFzWzZ7qJqB1t8j1O"
};